module.exports = __webpack_public_path__ + "static/hannah-stoddart-5eed246341c7a68e263391050dc028ab.png";